import React from 'react';
import { Truck, RotateCcw, CreditCard, Mail } from 'lucide-react';

const features = [
  {
    icon: Truck,
    title: 'Free Shipping',
    description: 'On orders $35+',
  },
  {
    icon: RotateCcw,
    title: '30-Day Returns',
    description: 'Hassle-free',
  },
  {
    icon: CreditCard,
    title: 'Secure Checkout',
    description: 'SSL encrypted',
  },
  {
    icon: Mail,
    title: 'Email Support',
    description: 'We respond in 24h',
  },
];

export const TrustBadges: React.FC = () => {
  return (
    <section className="bg-muted">
      <div className="container-wide py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div key={feature.title} className="flex items-center gap-3">
              <div className="bg-primary/10 p-3 rounded-full">
                <feature.icon className="h-6 w-6 text-primary" />
              </div>
              <div>
                <p className="font-semibold text-sm">{feature.title}</p>
                <p className="text-xs text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};